import type { RichTreeItem } from '../types';

/** True when the backend reports children for this node (placeholder or loaded). */
export function treeItemHasChildren(item: RichTreeItem | null | undefined): boolean {
  return Boolean(item?.children);
}

export function findTreeItem(items: RichTreeItem[], targetId: string): RichTreeItem | null {
  for (const item of items) {
    if (item.id === targetId) return item;
    if (item.children) {
      const found = findTreeItem(item.children, targetId);
      if (found) return found;
    }
  }
  return null;
}

export function findPathToNode(items: RichTreeItem[], targetId: string): string[] | null {
  const path: string[] = [];

  function dfs(nodes: RichTreeItem[]): boolean {
    for (const item of nodes) {
      path.push(item.id);
      if (item.id === targetId) return true;
      if (item.children && dfs(item.children)) return true;
      path.pop();
    }
    return false;
  }

  return dfs(items) ? path : null;
}
